import { render, staticRenderFns } from "./Community.vue?vue&type=template&id=7aef89f6&scoped=true&"
import script from "./Community.vue?vue&type=script&lang=ts&"
export * from "./Community.vue?vue&type=script&lang=ts&"
import style0 from "./Community.vue?vue&type=style&index=0&id=7aef89f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aef89f6",
  null
  
)

export default component.exports